import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import SignIn from './SignIn';
import NewPassword from './NewPassword';
import CustomSnackbar from '../Common/CustomSnackbar';
import NewUser from './NewUser';
import snackbarProps from '../../selectors/snackbar';
import { resetPasswordTokenVerify } from '../../actions/authentication';
import Logo from '../../assets/images/portable-logo.png';
import useStyles from './styles';
import accountActivation from '../../actions/activation-account';
import ActivationList from './ActivationList';

export default ({ handleLogin }) => {
  const classes = useStyles();
  const userType = new URLSearchParams(window.location.search).get('user_type');
  const [signIn, setSignIn] = useState(true);
  const [activation, setActive] = useState(false);
  const snackbarProp = useSelector(snackbarProps);
  const emailToken = new URLSearchParams(window.location.search).get('token');
  const paymentToken = new URLSearchParams(window.location.search).get('payment_token');
  const dispatch = useDispatch();

  useEffect(() => {
    if (emailToken) {
      dispatch(resetPasswordTokenVerify({ token: emailToken })).then((ack) => {
        setSignIn(!ack);
      });
    }
    if (paymentToken) {
      dispatch(accountActivation({ token: paymentToken })).then((ack) => {
        setActive(!ack);
      });
    }
  }, [dispatch, emailToken, paymentToken]);

  if (activation) {
    return <>
      <ActivationList />
    </>
  }

  return (
    <div className={classes.background}>
      <Grid container className={classes.gridContainer}>
        <Grid item sm={6} className={classes.gridItemPreview}>
          <Box className={classes.brandingWrapper}>
            <img src={Logo} alt="logo" className={classes.logoImage} />
            <Typography className={classes.brandName}>BRANDCIL</Typography>
            <Typography className={classes.brandSlogan}>
              Social&nbsp;Media&nbsp;Management&nbsp;Platform
            </Typography>
          </Box>
        </Grid>

        {userType !== 'new' && (
          <Grid item sm={6} className={classes.gridItemMain}>
            {signIn ? (
              <SignIn handleLogin={handleLogin} classes={classes} />
            ) : (
              <NewPassword setSignIn={setSignIn} classes={classes} token={emailToken} />
            )}
          </Grid>
        )}
        {userType === 'new' && (
          <Grid item sm={6} className={classes.gridItemMain}>
            <NewUser classes={classes} setSignIn={setSignIn} />
          </Grid>
        )}
      </Grid>

      <CustomSnackbar
        open={snackbarProp.open}
        message={snackbarProp.message}
        severity={snackbarProp.severity}
      />
    </div>
  );
};
